@if (widgetSettings.widgetType === widgetTypes.RiskMatrix) {
    <div style="max-width: 500px">
        @if (riskMatrixAnswer) {
            <cerrix-riskmatrix
                [OrganizationID]="widgetSettings.widgetParam"
                [readonly]="readonly"
                [(selected)]="riskMatrixAnswer"
                (selectedChange)="emitChange()"
            >
            </cerrix-riskmatrix>
        }
    </div>
}
